/**
 * Permission manager factory
 */

import { PermissionManager } from "../../../../src/services/permission-manager";

angular.module("modules:admin").factory("PermissionManager", function ($log) {
  return PermissionManager;
});
